import ctl from '@netlify/classnames-template-literals';

export const listStyle = ctl(`
  grid
  grid-cols-2
  gap-3
  mt-2
  h-[170px]
  overflow-y-auto
`);

export const messageStyle = ctl(`
  font-[600]
  text-xl
  opacity-30
`);

export const rowStyle = ctl(`
  max-w-[500px] 
  flex 
  items-center 
  border-b-[1px] 
  border-chinese-silver 
  p-2
`);

export const idColumnStyle = 'flex-[10%]';
export const nameColumnStyle = 'flex-[70%]';
export const iconColumnStyle = 'flex-[20%] text-xl cursor-pointer';
